import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const customerEsimEntity: Entity = {
  model: model,
  repository: repository,
}

export default customerEsimEntity
